import * as React from "react";
import { cn } from "@/app/utils/tw-merge";
import { X } from "lucide-react";

/** Tag chip editor — mỗi tag là 1 chip + nút X. Enter hoặc dấu phẩy để thêm,
 *  Backspace trên input rỗng để xoá tag cuối. */
export function TagInput({
  value,
  onChange,
  placeholder,
  className,
}: {
  value: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
  className?: string;
}) {
  const [text, setText] = React.useState("");
  const inputRef = React.useRef<HTMLInputElement>(null);

  const add = () => {
    const v = text.replace(/,/g, "").trim();
    if (v && !value.includes(v)) onChange([...value, v]);
    setText("");
  };

  const remove = (i: number) => {
    const next = value.slice();
    next.splice(i, 1);
    onChange(next);
  };

  return (
    <div
      className={cn(
        "flex min-h-9 flex-wrap gap-1.5 rounded-md border border-border bg-input-background px-3 py-1.5 cursor-text",
        className
      )}
      onClick={() => inputRef.current?.focus()}
    >
      {value.map((tag, i) => (
        <span
          key={`${tag}-${i}`}
          className="inline-flex items-center gap-1 rounded-md bg-accent text-accent-foreground border border-accent px-2 py-0.5 text-xs"
        >
          {tag}
          <button
            type="button"
            onClick={() => remove(i)}
            className="hover:text-foreground"
            aria-label="remove tag"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        ref={inputRef}
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            add();
          } else if (e.key === "Backspace" && !text && value.length) {
            onChange(value.slice(0, -1));
          }
        }}
        onBlur={add}
        placeholder={placeholder}
        className="flex-1 min-w-32 bg-transparent outline-none text-sm placeholder:text-muted-foreground"
      />
    </div>
  );
}
